import { Component, OnInit, OnChanges, Input } from '@angular/core';
import { IonicPage,ModalController, NavParams,ViewController } from 'ionic-angular';
@IonicPage()
@Component({
  selector: 'page-search',
  templateUrl: 'search.html',
})
export class SearchPage  implements OnInit {
  // term: any;
  @Input('header') header: any;
  @Input('list') list: any;
 
  newList = [];
 
  dataList = [];
 
  constructor(
    private modal: ModalController,
    public nvmPrms: NavParams,
    public viewCtrl :ViewController,
  ) { 
   let data = nvmPrms.get('data');
   this.header = data.header;
   this.list = data.list;
   this.newList = this.list;
console.log("data",data)
  }
 
 
  ngOnInit() {
    // this.newList.next(this.list);
  }
 
  onSearch(event) {
    if (event._value == 0) {
     this.newList = this.list;
   } else {
     var searchList = this.list.filter((search) => search.value.toLowerCase().includes(event._value.toLowerCase()));
       this.newList = searchList;
   }
  }
 
 
  onClose(item?) {
    this.viewCtrl.dismiss(item);
  }

  onDismiss() {
    this.viewCtrl.dismiss(false);
  }
 
 }
 




// WEBPACK FOOTER //
// ./src/pages/search/search.ts